import { Button } from '@/components/Button';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

interface ClearButtonProps {
  disabled?: boolean;
  onClick?: () => void;
}

export const ClearButton = ({ disabled, onClick }: ClearButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      buttonClassName={twMerge(
        'bg-purple-A713F6 gap-1.5',
        disabled && 'bg-purple-A713F6/60'
      )}
      textClassName="mt-[2px] text-2sm"
      text={t('common:clear')}
      leftIcon={
        <i className="-mt-[0.05px] ki-outline ki-cross-square text-white self-center !text-[17.5px]" />
      }
      disabled={disabled}
      onClick={onClick}
    />
  );
};
